module.exports = __webpack_public_path__ + "static/media/rakuMenu2022.71982470.pdf";